module.exports = __webpack_public_path__ + "static/16-a680aea00cc54061156ed3c6ee227567.png";